/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFilterSortAHighToLowIcon16Light } from './UiFilterSortAHighToLowIcon16Light';
import { UiFilterSortAHighToLowIcon16Regular } from './UiFilterSortAHighToLowIcon16Regular';
import { UiFilterSortAHighToLowIcon16Solid } from './UiFilterSortAHighToLowIcon16Solid';
import { UiFilterSortAHighToLowIcon20Light } from './UiFilterSortAHighToLowIcon20Light';
import { UiFilterSortAHighToLowIcon20Regular } from './UiFilterSortAHighToLowIcon20Regular';
import { UiFilterSortAHighToLowIcon20Solid } from './UiFilterSortAHighToLowIcon20Solid';
import { UiFilterSortAHighToLowIcon24Regular } from './UiFilterSortAHighToLowIcon24Regular';
import { UiFilterSortAHighToLowIcon24Solid } from './UiFilterSortAHighToLowIcon24Solid';
import { UiFilterSortAHighToLowIcon32Regular } from './UiFilterSortAHighToLowIcon32Regular';
import { UiFilterSortAHighToLowIcon64Regular } from './UiFilterSortAHighToLowIcon64Regular';
var sizes = {
    16: {
        light: UiFilterSortAHighToLowIcon16Light,
        regular: UiFilterSortAHighToLowIcon16Regular,
        solid: UiFilterSortAHighToLowIcon16Solid,
    },
    20: {
        light: UiFilterSortAHighToLowIcon20Light,
        regular: UiFilterSortAHighToLowIcon20Regular,
        solid: UiFilterSortAHighToLowIcon20Solid,
    },
    24: {
        regular: UiFilterSortAHighToLowIcon24Regular,
        solid: UiFilterSortAHighToLowIcon24Solid,
    },
    32: {
        regular: UiFilterSortAHighToLowIcon32Regular,
    },
    64: {
        regular: UiFilterSortAHighToLowIcon64Regular,
    },
};
export var UiFilterSortAHighToLowIcon = forwardRef('UiFilterSortAHighToLowIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
